var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"pl-0"},[_c('h4',{staticClass:"d-none d-lg-block invisible",staticStyle:{"color":"white"}},[_vm._v(".")]),_vm._l((_vm.articleList),function(article){return _c('MainArticle',{key:article.identifier,attrs:{"identifier":`${article.identifier}`,"article":article.content,"mountedCallback":_vm.mountConfirmation}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }